import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { WarningToaast } from "../toast/Toast";

export const AuthProvider: React.FC<any> = ({ routeName, children, level }) => {
  const location = useLocation();

  const navigate = useNavigate();
  let exp_time = localStorage.getItem("_et") ?? "0";

  useEffect(() => {
    switch (level) {
      case "authorize":
        if (Math.round(Date.now() / 1000) > parseInt(exp_time)) {
          navigate("/login", { replace: true });
          // localStorage.removeItem("_t");
          // localStorage.removeItem("_et");
          WarningToaast("ورود شما منقضی شده است");
        }
        break;
      case "auth":
        if (Math.round(Date.now() / 1000) < parseInt(exp_time)) {
          WarningToaast("دسترسی به پیج مورد نظر ندارید");
          navigate("/", { replace: true });
        }
        break;
      case "public":
        if (Math.round(Date.now() / 1000) > parseInt(exp_time)) {
          localStorage.removeItem("_t");
          localStorage.removeItem("_et");
        }
        break;
      default:
        break;
    }
  }, [location]);

  return children;
};
